
/**
 * @param {string} nodeName
 * @param {HTMLElement} node
 */
export function findImageAtomicBlock(nodeName, node) {
	// 大部分图片
	// if ((['p', 'div', 'center', 'figure'].includes(nodeName)) && node.querySelector('img')) {
	if (nodeName === 'img') {
		return {
			type: 'atomic',
			text: '[图片]'
		}
	}
}



// WEBPACK FOOTER //
// ./lib/convert/html/finder/findImageAtomicBlock.js